"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBestFittingLanguage = exports.parseRFC5646LanguageTag = void 0;
function parseRFC5646LanguageTag(tag) {
    // kinda incomplete i guess. maybe use library
    const [language, country] = tag.split("-");
    return { language, country };
}
exports.parseRFC5646LanguageTag = parseRFC5646LanguageTag;
function getBestFittingLanguage(info) {
    // todo: don't ignore country tag
    const supportedLanguages = new Set(info.supportedLanguageCodes.map((c) => parseRFC5646LanguageTag(c).language));
    const acceptedLanguageCodes = info.acceptedLanguageCodes.map((c) => parseRFC5646LanguageTag(c).language);
    return (acceptedLanguageCodes.find((acceptedLang) => supportedLanguages.has(acceptedLang)) ?? info.fallbackLanguageCode);
}
exports.getBestFittingLanguage = getBestFittingLanguage;
//# sourceMappingURL=utils.js.map